import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ExpandableContent from 'Component/ExpandableContent';

import './ProductTags.style';

/** @namespace Pwa/Component/ProductTags/Component */
export class ProductTags extends PureComponent {
    static propTypes = {
        productTags: PropTypes.array,
    };

    static defaultProps = {
        productTags: [],
    };

    state = {
        isExpanded: false,
    };

    componentDidMount() {
        const { isMobile } = this.props;

        if (!isMobile) {
            this.setState({ isExpanded: true });
        }
    }

    renderContent() {
        const { productTags } = this.props;

        return (
            <div block="ProductTags" elem="ProductIcons">
                {productTags.map(({ tag_code, image_url }) => {
                    if (tag_code === null) return;
                    return <img block="ProductTags" elem="ProductIcon" key={tag_code} src={image_url} alt={tag_code} />;
                })}
            </div>
        );
    }

    handleIsExpanded() {
        const { isExpanded } = this.state;
        this.setState({ isExpanded: !isExpanded });
    }

    render() {
        const { name, productTags } = this.props;
        const { isExpanded } = this.state;

        if (productTags.length === 1 && productTags[0].tag_code === null) return null;

        return (
            <div block="ProductTags">
                <ExpandableContent
                    mix={{ block: 'ProductTags', elem: 'Content' }}
                    heading={name}
                    onClick={this.handleIsExpanded.bind(this)}
                    id="ProductTags"
                    isExpandableOnDesktop
                    isContentExpanded={isExpanded}
                    iconVariant="secondary"
                >
                    {this.renderContent()}
                </ExpandableContent>
            </div>
        );
    }
}

export default ProductTags;
